import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCFjMILzETgDpfYS8IWhDf5i0wac9rWQPE",
  authDomain: "smartface-b81d3.firebaseapp.com",
  projectId: "smartface-b81d3",
  storageBucket: "smartface-b81d3.firebasestorage.app",
  messagingSenderId: "626301237833",
  appId: "1:626301237833:web:992f75346b213d9a23dd98",
  measurementId: "G-J17CJGF9HY"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);